const listeners=new Set<()=>void>();
/** Only LinkedWork's already trusted MessagePort calls this. No document mutation or credentials. */
export const resetAiInfographicUi=()=>{for(const listener of listeners)listener();};
export const subscribeAiInfographicReset=(listener:()=>void)=>{listeners.add(listener);return()=>{listeners.delete(listener);};};
